var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label || `Mobile Phone${_vm.required ? '*' : ''}:`,"label-for":_vm.makeId('mobile_phone'),"state":_vm.state,"invalid-feedback":_vm.invalid,"description":_vm.description}},[_c('VueTelInput',{ref:"telInput",attrs:{"default-country":_vm.SchoolSettings.country.alpha_2_code,"auto-default-country":false,"value":_vm.formattedNumber,"disabled":_vm.disabled,"mode":_vm.SchoolSettings.is_international_mobile_phone_format ? 'international' : 'national',"input-options":{
      id: _vm.makeId('mobile_phone'),
      name: _vm.makeName('mobile_phone'),
      styleClasses: { 'is-invalid': _vm.state === false, 'form-control': true },
      autocomplete: 'nope',
      placeholder: 'Enter a phone number',
    },"style-classes":{ 'is-invalid': _vm.state === false }},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }